/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.frozenCreateOrder.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/frozenCreateOrder/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
